import { AlertDialog } from '@twilio-paste/core/alert-dialog';

interface ConfirmationDialogProps {
  heading: string;
  text: string;
  confirmButtonLabel: string;
  isOpen: boolean;
  handleConfirm: VoidFunction;
  handleDismiss: VoidFunction;
  dismissButtonLabel?: string;
  destructive?: boolean;
  isConfirmDisabled?: boolean;
}

export function ConfirmationDialog({
  confirmButtonLabel,
  dismissButtonLabel = 'Cancel',
  isConfirmDisabled,
  handleConfirm,
  handleDismiss,
  destructive,
  heading,
  isOpen,
  text,
}: ConfirmationDialogProps) {
  return (
    <AlertDialog
      heading={heading}
      isOpen={isOpen}
      onConfirm={handleConfirm}
      onConfirmLabel={confirmButtonLabel}
      onDismiss={handleDismiss}
      onDismissLabel={dismissButtonLabel}
      destructive={destructive}
      isConfirmDisabled={isConfirmDisabled}
    >
      {text}
    </AlertDialog>
  );
}
